import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { useBooleanState } from 'libs.react';
const ImportStateContext = createContext(undefined);
export const ImportStateProvider = ({ children }) => {
    const [cloneCheckStatus, setCloneCheckStatus] = useState(undefined);
    const [selectedEligibleLocales, setSelectedEligibleLocales] = useState([]);
    const [targetLocalizationId, setTargetLocalizationId] = useState('');
    const [sourceLocalizationId, setSourceLocalizationId] = useState('');
    const [files, setFiles] = useState({});
    const [localeMap, setLocaleMap] = useState({});
    const [isFilesLoading, setFilesLoading, setFilesLoaded] = useBooleanState();
    const resetState = () => {
        setCloneCheckStatus(undefined);
        setSelectedEligibleLocales([]);
        setTargetLocalizationId('');
        setSourceLocalizationId('');
        setFiles({});
        setLocaleMap({});
        setFilesLoaded(); // Reset loading state to false
    };
    return (_jsx(ImportStateContext.Provider, { value: {
            cloneCheckStatus,
            setCloneCheckStatus,
            selectedEligibleLocales,
            setSelectedEligibleLocales,
            targetLocalizationId,
            setTargetLocalizationId,
            sourceLocalizationId,
            setSourceLocalizationId,
            files,
            setFiles,
            localeMap,
            setLocaleMap,
            isFilesLoading,
            setFilesLoading,
            setFilesLoaded,
            resetState,
        }, children: children }));
};
export const useImportState = () => {
    const context = useContext(ImportStateContext);
    if (context === undefined) {
        throw new Error('useImportState must be used within an ImportStateProvider');
    }
    return context;
};
